import classNames from 'classnames'
import Button from '~/components/Button'
import Dialog from '~/components/Dialog'
import type { FilterOption } from './Filters'
import Filters from './Filters'

interface ContainerwithContentFiltersProps {
  type: 'printable' | 'video'
  learningAreas?: FilterOption[] | null
  children?: React.ReactNode
}

const ContainerWithContentFilters = ({ type, learningAreas, children }: ContainerwithContentFiltersProps) => (
  <div className="mx-auto mb-8 max-w-8xl p-4 pt-8 sm:p-8">
    <div className="sticky top-2 z-30 -mb-8 flex justify-end sm:hidden">
      <Dialog
        position="left"
        title="Filters"
        content={
          <Filters
            type={type}
            learningAreas={learningAreas?.map(area => ({
              id: area.id,
              title: area.title || ''
            }))}
          />
        }
        trigger={<Button size="base" text="Filters" />}
      />
    </div>
    <div className="mb-4 flex items-center justify-between">
      <h1 className="my-0 text-3xl">{type[0]?.toUpperCase() + type.slice(1) + 's'}</h1>
      <div className="hidden w-28 place-items-center sm:grid ">
        <img src="/cub-club-logo.png" alt="Cub club logo" />
      </div>
    </div>
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-12 sm:gap-6 md:gap-8">
      <div className={classNames('hidden', 'sm:col-span-5 sm:block md:col-span-4 lg:col-span-3')}>
        <div className="sticky top-8">
          <Filters
            type={type}
            learningAreas={learningAreas?.map(area => ({
              id: area.id,
              title: area.title || ''
            }))}
          />
        </div>
      </div>
      <div className="col-span-1 sm:col-span-7 md:col-span-8 lg:col-span-9">{children}</div>
    </div>
  </div>
)

export default ContainerWithContentFilters
